export default {
  BASE_URL: 'category/',
  api: [
    {
      name: 'parentCategory',
      method: 'GET',
      desc: '获取招标一级分类',
      path: 'parentCategory',
      params: {
        bizId: 1,
        parentId: 0,
        all: true
      }
    },
    {
      name: 'childrenCategory',
      method: 'GET',
      desc: '获取招标二级分类',
      path: 'childrenCategory',
      params: {
        bizId: 1,
        parentId: 0,
        noPage: false
      }
    },
    {
      name: 'operateCategory',
      method: 'POST',
      desc: '添加编辑一、二级分类',
      path: 'operateCategory',
      params: {
        bizId: 1,
        parentId: 0,
        cataName: '',
        cataStatus: true,
        cataImage: '',
        keyWord: '',
        cataDesc: ''
      }
    },
    {
      name: 'currentCategoryinfo',
      method: 'GET',
      desc: '获取二级分类所需（排序号）',
      path: 'currentCategoryinfo',
      params: {
        id: '',
        bizId: 1
      }
    },
    {
      name: 'getCurrentCategoryinfo',
      method: 'GET',
      desc: '获取二级分类所需（排序号）',
      path: 'currentCategoryinfo',
      append: true,
      params: {
        id: '',
        bizId: 1
      }
    },
    {
      name: 'removeCategory',
      method: 'GET',
      desc: '删除一级二级分类',
      path: 'removeCategory',
      append: true,
      params: {
        id: '',
        isDeleted: true
      }
    },
    {
      name: 'operateCategoryStatus',
      method: 'POST',
      desc: '启用/停用一二级分类',
      path: 'operateCategoryStatus',
      params: {
        id: '',
        cataStatus: false
      }
    },
    {
      name: 'validateCategoryName',
      method: 'GET',
      desc: '检验一级或二级分类名称是否重复',
      path: 'validateCategoryName',
      params: {
        bizId: 1,
        parentId: '',
        categoryName: ''
      }
    },
    {
      name: 'tenderCategory',
      method: 'GET',
      desc: '返回招投标一级二级（启用）',
      path: 'tenderCategory',
      params: {
        bizId: 1,
        parentId: '',
        categoryName: ''
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/tender/category.js